export default __webpack_public_path__ + "static/media/gas.1aa0ee1f.jpg";